import styled from 'styled-components';
import { tenant } from '../../config/tenant';

/*
 * Home publica (redesign aprovado). Porte do css/home.css do pacote
 * "canal-do-repasse-home-aspx" para styled-components, escopado em HomeRoot.
 * Escopo: somente a home publica. Nao altera estilos das telas internas.
 */

const orange = tenant.colors.accent;

export const HomeRoot = styled.div`
	--cr-orange: ${orange};
	--cr-orange-dark: #b34700;
	--cr-orange-hover: #ff7a1f;
	--cr-ink: #141414;
	--cr-text: #3f3f46;
	--cr-muted: #5f5f66;
	--cr-line: #ececea;
	--cr-surface: #f7f7f5;
	--cr-footer: #141414;
	--cr-wa: #25d366;
	--cr-container: 1248px;

	margin: 0;
	background: #ffffff;
	color: var(--cr-ink);
	font-family: Inter, 'Segoe UI', Roboto, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	overflow-x: clip;
	min-height: 100vh;

	*,
	*::before,
	*::after {
		box-sizing: border-box;
	}

	a {
		color: var(--cr-orange-dark);
		width: auto;
	}
	a:hover {
		color: #8a3600;
	}
	img {
		max-width: 100%;
		height: auto;
	}

	.cr-container {
		max-width: var(--cr-container);
		margin: 0 auto;
		padding: 0 24px;
	}

	/* ---------- Botões e links ---------- */
	.cr-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		height: 46px;
		padding: 0 20px;
		border: 0;
		border-radius: 8px;
		background: var(--cr-orange);
		color: #ffffff;
		font: 600 14.5px/1 Inter, sans-serif;
		text-decoration: none;
		cursor: pointer;
		transition: background 0.15s;
	}
	a.cr-btn,
	a.cr-btn:hover {
		color: #ffffff;
	}
	a.cr-link-ul {
		color: var(--cr-ink);
	}
	.cr-btn:hover {
		background: var(--cr-orange-hover);
		color: #ffffff;
	}
	.cr-btn:disabled {
		opacity: 0.7;
		cursor: not-allowed;
	}
	.cr-btn--sm {
		height: 42px;
		padding: 0 22px;
		font-size: 14px;
	}
	.cr-btn--block {
		width: 100%;
	}
	.cr-btn .cr-arrow {
		width: 16px;
		height: 16px;
	}
	.cr-link-ul {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		color: var(--cr-ink);
		font: 600 14.5px Inter, sans-serif;
		text-decoration: none;
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
	}
	.cr-link-ul span {
		border-bottom: 1.5px solid currentColor;
		padding-bottom: 2px;
	}
	.cr-link-ul:hover {
		color: var(--cr-orange-dark);
	}
	.cr-link-or {
		display: inline-flex;
		align-items: center;
		gap: 10px;
		color: var(--cr-orange-dark);
		font: 600 15px Inter, sans-serif;
		text-decoration: none;
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
	}
	.cr-link-or span {
		border-bottom: 1.5px solid currentColor;
		padding-bottom: 2px;
	}
	.cr-arrow {
		width: 16px;
		height: 16px;
		flex-shrink: 0;
	}
	.cr-btn:focus-visible,
	.cr-link-ul:focus-visible,
	.cr-link-or:focus-visible,
	.cr-nav a:focus-visible,
	.cr-field:focus-visible,
	.cr-icon-btn:focus-visible {
		outline: 2px solid var(--cr-orange);
		outline-offset: 3px;
	}

	/* ---------- Tipografia de seção ---------- */
	.cr-eyebrow {
		display: inline-flex;
		align-items: center;
		gap: 12px;
		font: 500 12px/1 Inter, sans-serif;
		letter-spacing: 2px;
		text-transform: uppercase;
		color: var(--cr-muted);
	}
	.cr-eyebrow::before {
		content: '';
		display: inline-block;
		width: 28px;
		height: 2px;
		background: var(--cr-orange);
	}
	.cr-eyebrow--sm {
		font-size: 11px;
	}
	.cr-eyebrow--sm::before {
		width: 22px;
	}
	.cr-h2 {
		margin: 0;
		font-weight: 700;
		font-size: 40px;
		line-height: 1.12;
		letter-spacing: -0.03em;
		color: var(--cr-ink);
	}
	.cr-h2--sm {
		font-size: 34px;
	}
	.cr-lead {
		margin: 0;
		font-size: 16px;
		line-height: 1.6;
		color: var(--cr-muted);
	}
	.cr-lead--sm {
		font-size: 15px;
	}
	.cr-or {
		color: var(--cr-orange);
	}
	.cr-stack {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	/* ---------- Campos ---------- */
	.cr-field {
		width: 100%;
		height: 46px;
		padding: 0 14px;
		border: 1px solid #dcdcd9;
		border-radius: 8px;
		background: #ffffff;
		font: 400 14px Inter, sans-serif;
		color: var(--cr-ink);
		outline: none;
	}
	.cr-field::placeholder {
		color: #9a9aa0;
	}
	.cr-field:focus {
		border-color: var(--cr-orange);
		box-shadow: 0 0 0 3px rgba(255, 102, 0, 0.16);
	}
	.cr-field:disabled {
		background: #f5f5f3;
		cursor: not-allowed;
	}
	.cr-field--area {
		height: 96px;
		padding: 12px 14px;
		resize: vertical;
	}
	select.cr-field {
		appearance: none;
		padding-right: 40px;
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23141414' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
		background-repeat: no-repeat;
		background-position: right 14px center;
	}
	.cr-label {
		display: block;
		margin-bottom: 6px;
		font: 500 13px Inter, sans-serif;
		color: var(--cr-ink);
	}
	.cr-group {
		margin-bottom: 12px;
	}
	.cr-check {
		display: flex;
		align-items: center;
		gap: 8px;
		font: 400 13px Inter, sans-serif;
		color: var(--cr-text);
		cursor: pointer;
	}
	.cr-check input {
		width: 15px;
		height: 15px;
		margin: 0;
		accent-color: var(--cr-orange);
	}
	.cr-error {
		display: block;
		margin-top: 4px;
		font: 400 12px Inter, sans-serif;
		color: #c62828;
	}
	.cr-error--box {
		margin: 0;
		padding: 10px 12px;
		border-radius: 8px;
		background: #fff1f0;
		border: 1px solid #ffd5d0;
		font-size: 13px;
		line-height: 1.4;
	}
	.cr-success {
		display: block;
		margin: 0;
		padding: 10px 12px;
		border-radius: 8px;
		background: #effaf3;
		border: 1px solid #c9ead6;
		color: #1b5e20;
		font: 400 13px/1.4 Inter, sans-serif;
	}
	.cr-icon-btn {
		background: transparent;
		border: 0;
		cursor: pointer;
	}

	/* ---------- Header ---------- */
	.cr-header {
		position: sticky;
		top: 0;
		z-index: 30;
		background: #ffffff;
		border-bottom: 1px solid var(--cr-line);
	}
	.cr-header__in {
		position: relative;
		height: 72px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
	}
	.cr-logo {
		display: inline-flex;
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
	}
	.cr-logo img {
		height: 36px;
		width: auto;
		display: block;
	}
	.cr-nav {
		display: flex;
		align-items: center;
		gap: 32px;
		margin-right: 120px;
	}
	.cr-nav a {
		color: var(--cr-text);
		text-decoration: none;
		font: 500 15px Inter, sans-serif;
		padding: 8px 0;
		border-bottom: 2px solid transparent;
	}
	.cr-nav a:hover {
		color: var(--cr-ink);
		border-bottom-color: var(--cr-orange);
	}
	.cr-header__actions {
		display: flex;
		align-items: center;
		gap: 22px;
		flex-shrink: 0;
	}
	.cr-header__actions .cr-cad {
		color: var(--cr-ink);
		text-decoration: none;
		font: 500 14px Inter, sans-serif;
	}
	.cr-menu-btn {
		display: none;
		width: 44px;
		height: 44px;
		border: 0;
		background: transparent;
		cursor: pointer;
	}

	/* ---------- Hero ---------- */
	.cr-hero {
		position: relative;
		min-height: 560px;
		overflow: hidden;
		background: #ffffff;
	}
	.cr-hero__glow {
		position: absolute;
		left: calc(50% - 160px);
		top: 40px;
		width: 420px;
		height: 420px;
		border-radius: 999px;
		background: radial-gradient(closest-side, #ffe1cb 0%, #ffebdd 60%, rgba(255, 255, 255, 0) 100%);
		pointer-events: none;
	}
	.cr-hero__grid {
		position: relative;
		display: grid;
		grid-template-columns: minmax(0, 480px) minmax(0, 1fr) minmax(0, 330px);
		column-gap: 24px;
		align-items: start;
		padding-top: 48px;
		padding-bottom: 40px;
	}
	.cr-hero__copy {
		position: relative;
		z-index: 2;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding-top: 24px;
	}
	.cr-hero__title {
		margin: 0;
		font-weight: 700;
		font-size: 42px;
		line-height: 1.08;
		letter-spacing: -0.03em;
		color: var(--cr-ink);
	}
	.cr-hero__text {
		margin: 0;
		max-width: 480px;
		font-size: 15px;
		line-height: 1.6;
		color: var(--cr-muted);
	}
	.cr-hero__actions {
		display: flex;
		align-items: center;
		gap: 28px;
		flex-wrap: wrap;
		margin-top: 6px;
	}
	.cr-hero__media {
		position: relative;
		height: 480px;
		min-width: 0;
		z-index: 1;
	}
	.cr-hero__media img {
		position: absolute;
		right: 8px;
		top: 0;
		height: 480px;
		width: auto;
		max-width: none;
		display: block;
	}
	.cr-login {
		justify-self: end;
		width: 100%;
		max-width: 330px;
		margin-top: 8px;
		background: #ffffff;
		border: 1px solid var(--cr-line);
		border-radius: 16px;
		padding: 26px 24px 20px;
		display: flex;
		flex-direction: column;
		gap: 12px;
		box-shadow: 0 10px 30px rgba(20, 20, 20, 0.06);
	}
	.cr-login__title {
		font: 600 21px Inter, sans-serif;
		letter-spacing: -0.02em;
	}
	.cr-login__sub {
		font: 400 13px/1.5 Inter, sans-serif;
		color: var(--cr-muted);
		margin-bottom: 2px;
	}
	.cr-login .cr-group {
		margin-bottom: 0;
	}
	.cr-login__form {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.cr-pass {
		position: relative;
	}
	.cr-pass .cr-field {
		padding-right: 44px;
	}
	.cr-pass__toggle {
		position: absolute;
		right: 2px;
		top: 2px;
		width: 42px;
		height: 42px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 6px;
	}
	.cr-login__small {
		align-self: flex-start;
		padding: 0;
		border: 0;
		background: transparent;
		font: 500 13px Inter, sans-serif;
		color: var(--cr-orange-dark);
		cursor: pointer;
		text-align: left;
	}
	.cr-login__small:hover {
		color: #8a3600;
	}
	.cr-login__small:disabled {
		opacity: 0.6;
		cursor: default;
	}
	.cr-login__signup {
		margin: 0;
		font: 400 13px Inter, sans-serif;
		color: var(--cr-text);
	}
	.cr-login__signup a {
		font-weight: 600;
	}
	.cr-wa-pill {
		margin-top: 6px;
		display: flex;
		align-items: center;
		gap: 12px;
		height: 48px;
		padding: 0 14px;
		border-radius: 10px;
		background: #f4f4f2;
		color: var(--cr-ink);
		text-decoration: none;
		font: 600 13px Inter, sans-serif;
	}
	.cr-wa-pill:hover {
		color: var(--cr-ink);
		background: #efefec;
	}
	.cr-wa-pill span {
		flex: 1;
	}
	.cr-wa-dot {
		width: 30px;
		height: 30px;
		border-radius: 999px;
		background: var(--cr-wa);
		display: inline-flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		flex: 0 0 auto;
	}
	.cr-wa-dot svg {
		width: 18px;
		height: 18px;
	}

	/* ---------- Marcas ---------- */
	.cr-brands {
		background: var(--cr-surface);
		border-top: 1px solid var(--cr-line);
		border-bottom: 1px solid var(--cr-line);
	}
	.cr-brands__in {
		padding-top: 26px;
		padding-bottom: 26px;
		display: flex;
		align-items: center;
		gap: 36px;
		flex-wrap: wrap;
	}
	.cr-brands__caption {
		font: 500 11px/1.5 Inter, sans-serif;
		letter-spacing: 1.4px;
		text-transform: uppercase;
		color: var(--cr-muted);
		max-width: 190px;
	}
	.cr-brands__sep {
		width: 1px;
		height: 40px;
		background: #d9d9d6;
	}
	.cr-brands__strip {
		flex: 1;
		min-width: 320px;
		max-width: 960px;
		overflow-x: auto;
	}
	.cr-brands__strip img {
		display: block;
		min-width: 640px;
		width: 100%;
		height: auto;
	}

	/* ---------- Soluções ---------- */
	.cr-solutions {
		background: #ffffff;
	}
	.cr-solutions__in {
		padding-top: 72px;
		padding-bottom: 56px;
		display: flex;
		flex-direction: column;
		gap: 32px;
	}
	.cr-solutions__head {
		display: grid;
		grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
		gap: 48px;
		align-items: end;
	}
	.cr-solutions__head .cr-lead {
		max-width: 480px;
		justify-self: end;
	}
	.cr-product {
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		align-items: center;
		border-radius: 16px;
		overflow: hidden;
	}
	.cr-product--01 {
		background: var(--cr-surface);
	}
	.cr-product--02 {
		background: #ffffff;
		border: 1px solid var(--cr-line);
	}
	.cr-product__copy {
		padding: 48px 48px 48px 40px;
		display: flex;
		gap: 22px;
	}
	.cr-product--02 .cr-product__copy {
		padding: 48px 40px 48px 48px;
	}
	.cr-product__idx {
		font: 600 24px Inter, sans-serif;
		color: var(--cr-orange);
		letter-spacing: -0.02em;
		padding-top: 2px;
	}
	.cr-product__body {
		display: flex;
		flex-direction: column;
		gap: 14px;
		align-items: flex-start;
	}
	.cr-product__title {
		margin: 0;
		font: 600 24px/1.2 Inter, sans-serif;
		letter-spacing: -0.02em;
		color: var(--cr-ink);
	}
	.cr-product__photo {
		position: relative;
		height: 300px;
		overflow: hidden;
		background: var(--cr-ink);
	}
	.cr-product__photo img {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
	}
	.cr-laptop-wrap {
		position: relative;
		height: 300px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		padding: 16px 24px;
	}
	.cr-laptop-wrap img {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		display: block;
	}

	/* ---------- Quem somos ---------- */
	.cr-about {
		background: #ffffff;
		border-top: 1px solid var(--cr-line);
	}
	.cr-about__in {
		padding-top: 64px;
		padding-bottom: 72px;
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		gap: 48px;
		align-items: start;
	}
	.cr-about__copy {
		display: flex;
		flex-direction: column;
		gap: 16px;
		padding-right: 24px;
	}
	.cr-values {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		border-left: 1px solid var(--cr-line);
	}
	.cr-values > div {
		padding: 8px 28px;
		display: flex;
		flex-direction: column;
		gap: 14px;
		border-right: 1px solid var(--cr-line);
	}
	.cr-values > div:last-child {
		border-right: 0;
	}
	.cr-values svg {
		width: 40px;
		height: 40px;
	}
	.cr-values b {
		font: 600 15px Inter, sans-serif;
	}
	.cr-values span {
		font-size: 13.5px;
		line-height: 1.6;
		color: var(--cr-muted);
	}

	/* ---------- Contato ---------- */
	.cr-contact {
		background: var(--cr-surface);
		border-top: 1px solid var(--cr-line);
	}
	.cr-contact__in {
		padding-top: 64px;
		padding-bottom: 72px;
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		gap: 48px;
		align-items: start;
	}
	.cr-contact__copy {
		display: flex;
		flex-direction: column;
		gap: 16px;
		padding-right: 24px;
	}
	.cr-contact__copy .cr-lead {
		max-width: 380px;
	}
	.cr-wa-card {
		margin-top: 16px;
		max-width: 420px;
		display: flex;
		align-items: center;
		gap: 18px;
		padding: 20px 22px;
		border-radius: 12px;
		background: #ffffff;
		border: 1px solid var(--cr-line);
		text-decoration: none;
		color: var(--cr-ink);
	}
	.cr-wa-card:hover {
		color: var(--cr-ink);
	}
	.cr-wa-card .cr-wa-dot {
		width: 52px;
		height: 52px;
	}
	.cr-wa-card .cr-wa-dot svg {
		width: 28px;
		height: 28px;
	}
	.cr-wa-card__body {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.cr-wa-card__body b {
		font: 600 15px Inter, sans-serif;
	}
	.cr-wa-card__body small {
		font: 400 13px Inter, sans-serif;
		color: var(--cr-muted);
	}
	.cr-wa-card__phone {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		margin-top: 4px;
		font: 600 15px Inter, sans-serif;
		color: var(--cr-orange-dark);
	}
	.cr-form {
		background: #ffffff;
		border: 1px solid var(--cr-line);
		border-radius: 16px;
		padding: 28px;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}
	.cr-form .cr-group {
		margin-bottom: 0;
	}
	.cr-form__row {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
		gap: 16px;
	}
	.cr-form .cr-btn {
		align-self: flex-end;
	}

	/* ---------- Footer ---------- */
	.cr-footer {
		background: var(--cr-footer);
		color: #ffffff;
	}
	.cr-footer__in {
		padding-top: 48px;
		padding-bottom: 24px;
		display: flex;
		flex-direction: column;
		gap: 32px;
	}
	.cr-footer__grid {
		display: grid;
		grid-template-columns: minmax(0, 1.4fr) repeat(4, minmax(0, 1fr));
		gap: 32px;
	}
	.cr-footer__brand {
		display: flex;
		flex-direction: column;
		gap: 16px;
		padding-right: 24px;
		border-right: 1px solid #2a2a2e;
	}
	.cr-footer__brand img {
		height: 30px;
		width: auto;
		align-self: flex-start;
	}
	.cr-footer__brand p {
		margin: 0;
		font: 400 13px/1.6 Inter, sans-serif;
		color: #b8b8bc;
		max-width: 300px;
	}
	.cr-footer__col {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}
	.cr-footer__col b {
		font: 600 14px Inter, sans-serif;
		margin-bottom: 4px;
	}
	.cr-footer a,
	.cr-footer button.cr-footer__link {
		color: #b8b8bc;
		text-decoration: none;
		font: 400 14px Inter, sans-serif;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		background: none;
		border: 0;
		padding: 0;
		cursor: pointer;
		text-align: left;
	}
	.cr-footer a:hover,
	.cr-footer button.cr-footer__link:hover {
		color: #ffffff;
	}
	.cr-footer a svg {
		width: 14px;
		height: 14px;
	}
	.cr-footer__bottom {
		display: flex;
		justify-content: space-between;
		gap: 16px;
		flex-wrap: wrap;
		padding-top: 20px;
		border-top: 1px solid #2a2a2e;
		font: 400 12px Inter, sans-serif;
		color: #b8b8bc;
	}
	.cr-footer__legal {
		display: flex;
		gap: 10px;
		align-items: center;
	}
	.cr-footer__legal a {
		font-size: 12px;
	}
	.cr-footer__legal i {
		color: var(--cr-muted);
		font-style: normal;
	}

	/* ---------- WhatsApp flutuante ---------- */
	.cr-wa-fab {
		position: fixed;
		right: 28px;
		bottom: 28px;
		z-index: 40;
		width: 56px;
		height: 56px;
		border-radius: 999px;
		border: 0;
		background: var(--cr-wa);
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
	}
	.cr-wa-fab svg {
		width: 30px;
		height: 30px;
	}
	.cr-wa-menu {
		position: fixed;
		right: 28px;
		bottom: 100px;
		z-index: 40;
		width: 300px;
		max-width: calc(100vw - 56px);
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
		border: 1px solid #e8e8e5;
		padding: 14px;
		display: none;
		flex-direction: column;
		gap: 8px;
	}
	.cr-wa-menu.is-open {
		display: flex;
	}
	.cr-wa-menu__head {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 8px;
		font: 600 15px Inter, sans-serif;
	}
	.cr-wa-menu__close {
		width: 32px;
		height: 32px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
	.cr-wa-opt {
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding: 12px 14px;
		border-radius: 8px;
		border: 1px solid #e8e8e5;
		text-decoration: none;
		color: var(--cr-ink);
		background: #ffffff;
	}
	.cr-wa-opt:hover {
		background: #f6f6f4;
		color: var(--cr-ink);
	}
	.cr-wa-opt b {
		font: 600 14px Inter, sans-serif;
	}
	.cr-wa-opt span {
		font: 400 12px/1.5 Inter, sans-serif;
		color: var(--cr-muted);
	}

	/* ---------- Responsivo ---------- */
	@media (max-width: 1180px) {
		.cr-nav {
			margin-right: 40px;
			gap: 24px;
		}
	}
	@media (max-width: 1024px) {
		.cr-nav {
			display: none;
		}
		.cr-nav.is-open {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			position: absolute;
			left: 0;
			right: 0;
			top: 72px;
			margin: 0;
			padding: 16px 24px;
			gap: 8px;
			background: #ffffff;
			border-bottom: 1px solid var(--cr-line);
			box-shadow: 0 10px 24px rgba(20, 20, 20, 0.08);
		}
		.cr-menu-btn {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}
		.cr-hero__grid {
			grid-template-columns: minmax(0, 1fr) minmax(0, 330px);
			row-gap: 32px;
		}
		.cr-hero__media {
			grid-column: 1 / -1;
			order: 3;
			height: auto;
			display: flex;
			justify-content: center;
		}
		.cr-hero__media img {
			position: static;
			height: auto;
			width: min(100%, 360px);
		}
		.cr-solutions__head,
		.cr-product,
		.cr-about__in,
		.cr-contact__in {
			grid-template-columns: minmax(0, 1fr);
		}
		.cr-solutions__head .cr-lead {
			justify-self: start;
		}
		.cr-product--02 .cr-product__photo {
			order: -1;
		}
		.cr-values {
			grid-template-columns: minmax(0, 1fr);
			border-left: 0;
		}
		.cr-values > div {
			border-right: 0;
			border-bottom: 1px solid var(--cr-line);
			padding: 20px 0;
		}
		.cr-values > div:last-child {
			border-bottom: 0;
		}
		.cr-footer__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
		.cr-footer__brand {
			grid-column: 1 / -1;
			border-right: 0;
		}
	}
	@media (max-width: 720px) {
		.cr-hero__grid {
			grid-template-columns: minmax(0, 1fr);
		}
		.cr-login {
			justify-self: stretch;
			max-width: none;
		}
		.cr-hero__title {
			font-size: 34px;
		}
		.cr-header__actions .cr-cad {
			display: none;
		}
		.cr-product__copy,
		.cr-product--02 .cr-product__copy {
			padding: 28px 20px;
		}
		.cr-laptop-wrap {
			height: 220px;
		}
		.cr-form {
			padding: 20px;
		}
		.cr-footer__grid {
			grid-template-columns: minmax(0, 1fr);
		}
		.cr-brands__in {
			gap: 20px;
		}
		.cr-brands__sep {
			display: none;
		}
		.cr-brands__strip {
			flex-basis: 100%;
			min-width: 0;
			overflow: visible;
		}
		.cr-brands__strip img {
			min-width: 0;
			width: 100%;
		}
	}
`;
